'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildMessageKey = undefined;

var _pubnubMessageGetters = require('./pubnubMessageGetters');

var buildMessageKey = exports.buildMessageKey = function buildMessageKey(message) {
  return (0, _pubnubMessageGetters.getId)(message);
};